import { Pencil } from "lucide-react";

/**
 * 押すと直せるチップ。**チップの右に鉛筆を添える**。
 *
 * チップは青字＋下線ではないので、**押せること自体が見えない**。値そのものが
 * 枠と色を持っていて、クリックできる文字（[[InlineEditCell]] / [[LinkCell]]）と
 * 見た目が揃わないためで、印が無いと押すまで分からない。印の意味はほかの列と
 * 同じに揃える:
 *
 * - 鉛筆（ここ）… 押すと直せる（その場でもダイアログでも）
 * - 右上向きの矢印 … 画面が移る（[[LinkCell]]）
 *
 * **直せないときは鉛筆を出さない。** 権限が無い人や、除外した行のように手を
 * 入れられない値では、素のチップに戻して「押しても何も起きない」ことを見せる。
 */
export default function EditableChip({
  label,
  title,
  canWrite = true,
  onPress,
  children,
}: {
  /** 読み上げ用の説明（例: `3 行目の図面を紐付け`）。 */
  label: string;
  /** ホバーで出す補足。何が起きるか一言で言えるときだけ付ける。 */
  title?: string;
  /** false なら素のチップを出す（押せない）。 */
  canWrite?: boolean;
  onPress: () => void;
  /** 見せるチップ。 */
  children: React.ReactNode;
}) {
  if (!canWrite) return <>{children}</>;
  return (
    <button
      type="button"
      aria-label={label}
      title={title}
      onClick={onPress}
      // 押せることは鉛筆で示すが、触れたときにも返事を返す（鉛筆だけだと
      // チップ自身が押す場所なのか、鉛筆が押す場所なのか分かりにくい）。
      className="inline-flex cursor-pointer items-center gap-1 rounded-full outline-none hover:opacity-70 focus-visible:ring-2 focus-visible:ring-brand-400"
    >
      {children}
      <Pencil size={12} className="shrink-0 text-brand-500" aria-hidden />
    </button>
  );
}
